import pmeLogo from "../../assets/brand/pme-cake-full.svg";
import peopleWordmark from "../../assets/brand/people-wordmark.svg";
import peopleWordmarkReversed from "../../assets/brand/people-wordmark-reversed.svg";

/**
 * The official PME Cake logo with the PEOPLE wordmark beside it.
 *
 * Brand rule: the PME logo is used exactly as supplied — never recoloured,
 * redrawn, cropped or combined into another mark. It is rendered from the
 * committed official SVG at its own aspect ratio (only the height is set),
 * and never narrower than 76px, below which the brand rules require the
 * reduced logo instead. PEOPLE is separate artwork placed next to it with
 * clear space and a divider.
 */
export default function BrandLockup({
  size = "md",
  reversed = false,
  stacked = false,
  className = "",
}: {
  size?: "sm" | "md" | "lg";
  /** Use on navy surfaces: white wordmark and a light divider. */
  reversed?: boolean;
  /** PME logo above the wordmark, for narrow or centred placements. */
  stacked?: boolean;
  className?: string;
}) {
  // Heights keep the full PME logo at or above 76px wide (ratio 1.53:1).
  const logoH = size === "lg" ? "h-[76px]" : size === "sm" ? "h-[50px]" : "h-[54px] sm:h-[58px]";
  const wordH = size === "lg" ? "h-[30px]" : size === "sm" ? "h-[17px]" : "h-[21px] sm:h-[24px]";
  const wordmark = reversed ? peopleWordmarkReversed : peopleWordmark;

  if (stacked) {
    return (
      <div className={`flex flex-col items-center gap-4 ${className}`}>
        <img src={pmeLogo} alt="PME Cake" className={`${logoH} w-auto`} />
        <img src={wordmark} alt="People" className={`${wordH} w-auto`} />
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img src={pmeLogo} alt="PME Cake" className={`${logoH} w-auto shrink-0`} />
      <span
        aria-hidden
        className={`w-px self-stretch ${reversed ? "bg-white/25" : "bg-pme-blue/25"}`}
      />
      <img src={wordmark} alt="People" className={`${wordH} w-auto`} />
    </div>
  );
}
